import "../../../node_modules/@vanilla-extract/webpack-plugin/vanilla.virtual.css?%7B%22fileName%22%3A%22src%2Flayouts%2FLayout%2FLayout.css.ts.vanilla.css%22%2C%22source%22%3A%22Ll82dmk4aHYxIHsKICBmbGV4LWdyb3c6IDE7Cn0KLl82dmk4aHY3IHsKICBvcmRlcjogMTA7Cn0%3D%22%7D"
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var afterBodyCol = '_6vi8hv7';
export var beforeBodyCol = '_6vi8hv6';
export var body = _7a468({defaultClassName:'_6vi8hv2',variantClassNames:{},defaultVariants:{},compoundVariants:[]});
export var container = '_6vi8hv3';
export var contentCol = '_6vi8hv5';
export var grid = '_6vi8hv4';
export var main = '_6vi8hv1';
export var root = _7a468({defaultClassName:'_6vi8hv0',variantClassNames:{},defaultVariants:{},compoundVariants:[]});
export var sidebarCol = '_6vi8hv8';